import React from 'react';
import FilteredAutomationList from '../components/FilteredAutomationList';

const SellingAgentsOnly = () => {
    const breadcrumbItems = [
        { label: 'Home', href: '/' },
        { label: 'Automation Trigger', href: '/automation' },
        { label: 'Selling Agents Only', active: true }
    ];

    return (
        <FilteredAutomationList
            completionStatus="selling_agents_only"
            title="Selling Agents Only"
            subtitle="Automation runs where only selling agents are present"
            breadcrumbItems={breadcrumbItems}
        />
    );
};

export default SellingAgentsOnly;